export default __webpack_public_path__ + "static/media/phoneFilled.99ee62f6.svg";